/* -------------------------------------------------------------------------- *
 * Tabbed Content *
 * -------------------------------------------------------------------------- */

const settings = {
    selector: '.js-tab',
    state_class: 'is-active',
};

let activeTab;

class TabButton {
    constructor(el) {
        /* ------------------ *
         * Attributes Example *
         * ------------------ *
         * Trigger Element:
         * id="tab1" class="js-tab is-active" role="tab" aria-selected="true"
         * aria-controls="js-tabPanel1"
         *
         * Target Element:
         * id="js-tabPanel1" class="is-active" tabindex="-1" role="tabpanel"
         * aria-labelledby="tab1"
         */

        const aria = {
            selected: el.getAttribute('aria-selected'),
            controls: el.getAttribute('aria-controls'),
        };

        this.trigger_el = el;
        this.target_el = document.getElementById(aria.controls);

        if (aria.selected === 'true') {
            activeTab = this;
        }

        el.addEventListener('click', () => this.switchTabs());
    }

    switchTabs() {
        // Deactivate current tab
        activeTab.trigger_el.classList.remove(settings.state_class);
        activeTab.trigger_el.setAttribute('aria-selected', false);
        activeTab.target_el.classList.remove(settings.state_class);
        activeTab.target_el.setAttribute('hidden', true);

        // Activate new tab
        this.trigger_el.classList.add(settings.state_class);
        this.trigger_el.setAttribute('aria-selected', true);
        this.target_el.classList.add(settings.state_class);
        this.target_el.removeAttribute('hidden');

        //this.target_el.focus();

        activeTab = this;
    }
}

/* ------------- *
 * Public Export *
 * ------------- */

const Tabs = {
    init(selector = settings.selector) {
        const tab_els = document.querySelectorAll(selector);
        const tab_arr = Array.from(tab_els);

        tab_arr.forEach((el) => new TabButton(el));
        document.getElementById('tab1').click();
    },
};

export default Tabs;
